import { css } from '@emotion/react';

import { ReactNode } from 'react';

import { Spacing } from 'chatie-design-system';

import { safeArea } from '../../styles/css';
import { CSSProps } from '../../utils/misc';

type Props = {
  top?: boolean;
  bottom?: boolean;
  children?: ReactNode;
};

const safeareaCSS = css`
  position: relative;
  max-width: inherit;
`;

const SafeArea = ({ className, top, bottom, children }: Props & CSSProps) => {
  return (
    <div
      className={className}
      css={[
        safeareaCSS,
        top ? safeArea('top') : undefined,
        bottom ? safeArea('bottom', 'padding', Spacing.medium) : undefined,
      ]}
    >
      {children}
    </div>
  );
};

export default SafeArea;
